import { render, staticRenderFns } from "./BlockRepeaterItem.vue?vue&type=template&id=e594d972&scoped=true"
import script from "./BlockRepeaterItem.vue?vue&type=script&lang=js"
export * from "./BlockRepeaterItem.vue?vue&type=script&lang=js"
import style0 from "./BlockRepeaterItem.vue?vue&type=style&index=0&id=e594d972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e594d972",
  null
  
)

export default component.exports